<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Atribuição de cota para unidade solicitante"
    >
        <Form
            :data="data"
            :item="item"
            :indexLaboratorio="indexLaboratorio"
            @save="handleExit"
            ref="Form"
        />

         <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from './Form'

// Mixins.
import { repository, object, data, mask, formats } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { Form },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        indexLaboratorio: null,
        item: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item) {

            this.indexLaboratorio = index
            this.item = item

            if (item.unidadeAlterada) {
                this.$refs.Modal.show()
            } else {

                this.getCotaLaboratorioUnidade(item)
            }
        },
        handleExit(data) {

            this.$emit('save', data)
        },
        handleSave() {

            this.$refs.Form.save()
        },
        getCotaLaboratorioUnidade(item) {

            this.setLoading()

            this.repositories.parametrizacao.getCotaLaboratorioUnidade({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                cota_id: item.id,
                inicio: moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                fim: moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            })
                .then(response => {

                    this.item.unidadeSolicitante = response.data
                    item.unidadeSolicitante = response.data
                    item.unidadeAlterada = true

                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, object, data, mask, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>